var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: { "close-on-content-click": false },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "btn--plain",
                    attrs: { icon: "" },
                    on: { click: _vm.focusSearch }
                  },
                  on
                ),
                [_c("v-icon", [_vm._v("search")])],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { "min-width": "300px" } },
        [
          _c(
            "v-list",
            { staticClass: "pa-0" },
            [
              _c(
                "v-list-item",
                { staticClass: "pa-0", attrs: { dense: "" } },
                [
                  _c(
                    "v-list-item-content",
                    { staticClass: "pa-0" },
                    [
                      _c("v-text-field", {
                        ref: "searchbox",
                        attrs: {
                          label: "Search",
                          outlined: "",
                          solo: "",
                          clearable: "",
                          dense: "",
                          "append-icon": "search",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-list",
            { staticClass: "pt-0 scroll-search" },
            [
              _vm._l(_vm.filteredSearch, function(group) {
                return [
                  _c(
                    "v-subheader",
                    { key: group.value, attrs: { dense: "" } },
                    [_vm._v(_vm._s(group.value))]
                  ),
                  _vm._v(" "),
                  _vm._l(group.items, function(item) {
                    return _c(
                      "v-list-item",
                      {
                        key: group.value + "|" + item.id,
                        attrs: { to: group.url + item.id },
                        on: { click: _vm.closeMenu }
                      },
                      [_c("v-list-item-title", [_vm._v(_vm._s(item.name))])],
                      1
                    )
                  })
                ]
              }),
              _vm._v(" "),
              !_vm.filteredSearch.length
                ? _c(
                    "v-list-item",
                    [_c("v-list-item-title", [_vm._v("No results found")])],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7797e7b6", { render: render, staticRenderFns: staticRenderFns })
  }
}